export const SkillLevel = [
  { id: 1, step: "Beginner", stepColor: "#eff7e8" },
  { id: 2, step: "Intermediate", stepColor: "#b8e5b8" },
  { id: 3, step: "Advanced", stepColor: "#7cc67a" },
  { id: 4, step: "Expert", stepColor: "#26a977" }
];
